import React, { useState } from "react";
import "./EmployeeLogin.css"; // Reuse the employee login styling
import { useNavigate } from "react-router-dom";
import fetchBase from "../utils/fetchBase";

const AdminLogin = () => {
    const [step, setStep] = useState(1);
    const [input, setInput] = useState(""); // email or phone
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNext = () => {
        const isEmail = /\S+@\S+\.\S+/.test(input);
        const isPhone = /^\d{10}$/.test(input);
        if (!isEmail && !isPhone) {
            setError("Enter a valid email or 10-digit phone number");
            return;
        }
        setError("");
        setStep(2);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {


            const response = await fetch(`${fetchBase}/api/admin/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: input.toLowerCase().trim(),
                    password: password,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem("admin_id", data.id);
                localStorage.setItem("admin_email", data.email);// ✅ uses backend-validated email
                localStorage.setItem("admin_org", data.organizationName);
                localStorage.setItem("jwt_token", data.token);
                localStorage.setItem("role", "admin");
                localStorage.removeItem("isDemo");



                //const authHeader = "Basic " + btoa(`${data.email}:${password}`);
                //localStorage.setItem("authHeader", authHeader);

                navigate("/admin-dashboard");
            } else {
                const errorText = await response.text();
                setError("Incorrect user or password");
                setStep(1);
                setInput("");
                setPassword("");
                setTimeout(() => setLoading(false), 1000);
            }
        } catch (error) {
            console.error("Login error:", error);
            setError("Something went wrong. Try again.");
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <h2 className="title">Admin Login</h2>

                {step === 1 && (
                    <form className="login-form" onSubmit={(e) => { e.preventDefault(); handleNext(); }}>
                        <input
                            className="input"
                            type="text"
                            placeholder="Email or Phone Number"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            required
                        />
                        {error && <p className="error" style={{ color: 'red', fontSize: '0.9rem' }}>{error}</p>}
                        <button type="submit" className="submit-button">Next</button>
                    </form>
                )}

                {step === 2 && (
                    <form className="login-form" onSubmit={handleLogin}>
                        <input
                            className="input"
                            type="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        {error && <p className="error" style={{ color: 'red', fontSize: '0.9rem' }}>{error}</p>}
                        <button type="submit" className="submit-button" disabled={loading}>
                            {loading ? "Authorizing..." : "Sign In"}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default AdminLogin;
